import React, { Suspense } from "react";
import FocusServiceCard from "../cards/FocusServiceCard";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { ConditionalSwiper } from "../../components/shared/conditionalSwiper";

const Brochure = React.lazy(() => import("components/shared/brochure"));

const ServiceInfo = ({
  keyIcons,
  iconset = "locations",
  programType,
  scholarships,
  scholarshipBackgroundImage,
  scholarshipFeatureImage,
  scholarshipTitle,
  scholarshipDescription,
  scholarshipCtaLink,
  serviceInfoSectionClass,
  sectionContainerStyles,
  imageContainerClass,
  showBrochure = false,
  setOpenModal,
  openModal
}) => {
  const iconParentKey = [
    "kmi",
    iconset.toLowerCase().charAt(0).toUpperCase(),
    iconset.toLowerCase().slice(1)
  ].join("");

  const keyMsgIcons = keyIcons[iconParentKey] ?? keyIcons ?? [];

  const iconsetKey = (iconName) => [iconParentKey, iconName].join("");
  const breakpoint = useBreakpoint();

  const serviceCards =
    keyMsgIcons?.length > 0
      ? keyMsgIcons?.map((icon) => {
          return {
            icon:
              icon[`${iconsetKey("Icon")}`]?.localFile?.publicURL ??
              icon[`${iconsetKey("Icon")}`].sourceUrl,
            title: icon[`${iconsetKey("Title")}`],
            description: icon[`${iconsetKey("Desc")}`]
          };
        })
      : [];

  if (serviceCards?.length < 1) {
    return <></>;
  }

  return (
    <>
      <Suspense>
        <section
          className={
            serviceInfoSectionClass
              ? serviceInfoSectionClass
              : `flex flex-col items-center px-4 py-6 sm:py-12 md:px-0 summary-section planet:gvi-light-gray-bg bg-generic-bg`
          }
        >
          {(scholarships || scholarshipTitle) && showBrochure && (
            <Brochure
              scholarships={scholarships}
              scholarshipBackgroundImage={scholarshipBackgroundImage}
              scholarshipFeatureImage={scholarshipFeatureImage}
              scholarshipTitle={scholarshipTitle}
              scholarshipDescription={scholarshipDescription}
              scholarshipCtaLink={scholarshipCtaLink}
              setOpenModal={setOpenModal}
              openModal={openModal}
              formType={"itinerary_under18_form"}
              calendlyActive={false}
            />
          )}
          <div className="container flex flex-col items-start w-full md:flex-row md:w-5/6 md:gap-4">
            <div className="w-full md:sticky-left-section md:pr-10">
              <div className="grid grid-cols-1 gap-2 md:grid-cols-3">
                <ConditionalSwiper
                  condition={breakpoint === "xs"}
                  slidesPerView={1.25}
                  spaceBetween={10}
                  centeredSlides={false}
                  className="w-full h-full"
                >
                  {serviceCards &&
                    serviceCards.length > 0 &&
                    serviceCards.map((service, index) => (
                      <FocusServiceCard
                        key={index}
                        icon={service.icon}
                        title={service.title}
                        description={service.description}
                        className="h-full"
                        imageContainerClass={imageContainerClass}
                      />
                    ))}
                </ConditionalSwiper>
              </div>
            </div>
          </div>
        </section>
      </Suspense>
    </>
  );
};

ServiceInfo.defaultProps = {
  sectionContainerStyles: "bg-generic-bg",
  imageContainerClass: "bg-yellow-lighter"
};

export default ServiceInfo;
